import axios from 'axios';
import { constants } from '@skunexus/utils';

const { API_PATH } = constants.CONFIG;

export function fetchDictionaries() {
    const query = `
        query V1Queries {
            warehouse {
                grid(sort: {name: ASC}, limit: {size: 9999, page: 0}) {
                    rows {
                        value: id
                        label
                    }
                }
            }
        }
      `;

    return axios.post(`${API_PATH}/query`, { query });
}
